// Canvas wrapper. Hosts either the v1 gridstack scene or the v2
// state-driven surface based on `isCanvasV2`. v1-era input handlers
// (cursor toggling, panningMode flag) are gated so they don't fight
// the v2 pointer pipeline.

const v1Only = (handler) => (ev, el, s) => {
  if (el.call('isCanvasV2')) return
  return handler(ev, el, s)
}

export const Canvas = {
  tag: 'main',
  position: 'absolute',
  inset: '0',
  overflow: 'hidden',
  boxSize: '100%',
  overscrollBehavior: 'none',
  userSelect: 'none',
  theme: 'document',
  background: '#8a9096',

  // v1 dotted background. v2 renders its own grid inside CanvasSurface
  // so it pans/zooms with the viewport.
  Dots: {
    if: (el) => !el.call('isCanvasV2'),
    position: 'absolute',
    inset: '0',
    display: 'block',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    style: {
      backgroundPosition: '0 0',
      backgroundRepeat: 'repeat',
      backgroundSize: '20px 20px',
      backgroundImage:
        'radial-gradient(circle, rgba(255,255,255,0.15) 1px, transparent 1px)'
    }
  },

  CanvasScene: { if: (el) => !el.call('isCanvasV2') },
  CanvasSurface: { if: (el) => el.call('isCanvasV2') },

  onRender: (el) => {
    if (el.__scrollPrevented) return
    el.__scrollPrevented = true

    const gs = el.context?.globalScope
    if (gs) {
      gs.canvasElement = el
      window.__canvasGlobalScope = gs
    }

    el.context.document.documentElement.setAttribute('data-theme', 'dark')

    const preventScroll = (e) => e.preventDefault()
    document.body.addEventListener('wheel', preventScroll, { passive: false })
    document.body.addEventListener('touchmove', preventScroll, { passive: false })
  },

  onClick: v1Only((ev, el) => {
    const gs = el.context?.globalScope
    if (gs) { gs.selected = null; gs.selectedKey = null; gs.hovered = null; gs.hoveredKey = null }
  }),
  onContextmenu: (ev) => ev.preventDefault(),
  onMousemove: v1Only((ev, el) => {
    const gs = el.context?.globalScope
    if (gs) gs.positions = { ...gs.positions, mouseX: ev.clientX, mouseY: ev.clientY }
  }),
  onKeydown: v1Only((ev, el) => {
    if (ev.code === 'Space' && !ev.repeat) {
      ev.preventDefault()
      const gs = el.context?.globalScope
      if (gs) gs.panningMode = true
      el.node.style.cursor = 'grab'
    }
  }),
  onKeyup: v1Only((ev, el) => {
    if (ev.code === 'Space') {
      const gs = el.context?.globalScope
      if (gs) { gs.panningMode = false; gs.isGrabbing = false }
      el.node.style.cursor = 'auto'
    }
  }),
  onMousedown: v1Only((ev, el) => {
    const gs = el.context?.globalScope
    if (gs?.panningMode) { gs.isGrabbing = true; el.node.style.cursor = 'grabbing' }
  }),
  onMouseup: v1Only((ev, el) => {
    const gs = el.context?.globalScope
    if (gs?.isGrabbing) { gs.isGrabbing = false; el.node.style.cursor = gs.panningMode ? 'grab' : 'auto' }
  })
}
